import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment"
import _ from 'lodash';
import Fuse from 'fuse.js';

import { TextInputField, DropDownField, AutoCompleteField, CalendarField, Button, CheckboxField, TextAreaField } from "../../helpers";
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { Tooltip } from "primereact/tooltip";

import { Document, Page } from 'react-pdf'

import './index.css'

import Loading from '../../common/Loading';
import UserProfile from '../../common/UserProfile';
import Attachment from '../../common/Attachment';
import FileDisplay from '../../common/FileDisplay';
import DocumentView from '../../common/DocumentView';
import StructuredCommentModel from './components/StructuredCommentModel';

import { fetchTicketCategory, fetchTicketSubCategory, fetchTicketStatus, fetchTicketGroupAssignee, fetchTicketConstraintAssignees, fetchTicketDetailedStatus, fetchLastCommentStructures } from "../../services/redux/reducers/commonThunk";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getTicketById, updateTicketFields, getTicketCommentsByTicketId, addTicketComment, reOpenTicket } from '../../services/api/tickets'
import { getCompanyListByCompanyId, getBuyerCompanies } from '../../services/api/company';
import { getFollowerList, getCompanyBranchesByCompanyId } from '../../services/api/tickets';
import { fetchTicketList, updateSearchParams, updateTicketsData } from "../../services/redux/reducers/tickets/tickets";

import { getFullName } from '../../utils';
import { DATE_TIME_FORMAT, DATE_FORMAT }  from '../../constants'

import TicketEditSkeleton from '../../skeletons/TicketEdit';
import { checkPermissions } from '../../utils';

import { sortArrayOfObjectsInAlphabeticalOrder } from '../../utils';


const TicketEdit = () => {
    const { id } = useParams()

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const ticketCategoies = useSelector(state => state.common.ticketCategories)
    const ticketSubCategoies = useSelector(state => state.common.ticketSubCategories)
    let ticketGroupAssignee = useSelector(state => state.common.ticketGroupAssignee)
    let ticketStatus = useSelector(state => state.common.ticketStatus)
    let ticketConstraintAssignees = useSelector(state => state.common.ticketConstraintAssignees)
    const activeUserRoleDetails = useSelector((state) => state.userDetails.activeUserRoleDetails)
    let ticketList = useSelector(state => state.ticketsData.ticketList)
    const paginationParams = useSelector(state => state.ticketsData.paginationParams)
    const searchParams = useSelector(state => state.ticketsData?.searchParams)
    let ticketDetailedStatus = useSelector(state => state.common.ticketDetailedStatus)
    let lastCommentStructure = useSelector(state => state.common.lastCommentStructures)

    const userDetails = useSelector(state => state.userDetails)
    const PMCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const userId = userDetails.userId
    const usersList = userDetails.PMCompanyDetails.companyUsers

    const [initialTicketData, setInitialTicketData] = useState([])

    const [ searchedFollowerNames, setSearchedFollowerNames ] = useState([])
    const [ selectedFollower, setSelectedFollower ] = useState()
    const [ isInitialLoading, setIsInitialLoading ] = useState(true)
    const [ isLoading, setIsLoading ] = useState(false)

    const [ ticketObj, setTicketObj ] = useState({})
    const [ userList, setUserList ] = useState([])

    const [ searchedAssigneeNames, setSearchedAssigneeNames ] = useState([])
    const [ selectedAssignee, setSelectedAssignee ] = useState()

    const [ isUpdateEnabled, setIsUpdateEnabled ] = useState(false)
    const [ isStatusClosed, setIsStatusClosed ] = useState(false)

    let [ commentList, setCommentList ] = useState([])
    let [ ticketComment, setTicketComment] = useState()
    let [ commentDocument, setCommentDocument ] = useState()
    let [ uploadedCommentFileView, setUploadedCommentFileView ] = useState(false)
    let [ uploadedFileView, setUploadedFileView ] = useState(false)
    let [ commentUploadedFile, setCommentUpladedFile] = useState({})
    let [ updateAccessUserArr, setUpdateAccessUserArr] = useState([])

    const [ defaultTicketAssignees, setDefaultTicketAssignees ] = useState([])
    const [ticketCategoryName, setTicketCategoryName] = useState(null)
    const [dueDateLock, setDueDateLock] = useState(null)
    const [assigneeLock, setAssigneeLock] = useState(null)
    const [allowOnHold, setAllowOnHold] = useState(null)
    const [creatorCloseOnly, setCreatorCloseOnly] = useState(null)
    const [selectedAssigneeList, setSelectedAssigneeList] = useState([])
    const [selectedFollowerList, setSelectedFollowerList] = useState([])
    const [allowViewTicket, setAllowViewTicket] = useState(true)
    const [emailAlert, setEmailAlert] = useState(null)
    const [ ticketSubCategoryList, setTicketSubCategoryList ] = useState([])
    const [initialTicketSubCategory, setInitialTicketSubCategory] = useState(null)
    const [selectedSubCategoryName, setSelectedSubCategoryName] = useState(null)
    const [isSubCategoryEditable, setIsSubCategoryEditable] = useState(null)
    const [companyList, setCompanyList] = useState([])
    const [companyBranchList, setCompanyBranchList] = useState([])
    const [disableCompanyAndBranchName, setDisableCompanyAndBranchName] = useState(true)
    const [showDetailedStatus, setShowDetailedStatus] = useState(true)
    const [showStructuredCommentModel, setShowStructuredCommentModel] = useState(false)
    const [addCommentTriggered, setAddCommentTriggered] = useState(false)
    const [isTicketStatusChanged, setIsTicketStatusChanged] = useState(false)
    const [initialTicketStatusId, setInitialTicketStatusId] = useState(null)
    const [isReOpenAllow, setIsReOpenAllow] = useState(null)
    const [buyerCompanies, setBuyerCompanies] = useState([])
    const [companySuggestions, setCompanySuggestions] = useState([])

    const [selectedFile, setSelectedFile] = useState('')

    const [initialSubCategoryIdAllowed, setInitialSubCategoryIdAllowed] = useState(true)
    const [selectedCompanyId, setSelectedCompanyId] = useState(null)
    const [selectedBranchId, setSelectedBranchId] = useState(null)
    const [companyName, setCompanyName] = useState(null)
    const [isDocDialogVisible, setIsDocDialogVisible] = useState(false)


    let displayTicketStatuses = ticketStatus ?  JSON.parse(JSON.stringify(ticketStatus)) : []

    if (displayTicketStatuses.length) {
        displayTicketStatuses = displayTicketStatuses
        .filter(eachFilteredStatus => ![3, 4].includes(eachFilteredStatus.ticketStatusId))
            .map(eachStatus => {
                eachStatus.disabled = true
                if (eachStatus.ticketStatusId === 1 || eachStatus.ticketStatusId === 10) {
                    eachStatus.disabled = false
                }
                else if (eachStatus.ticketStatusId === 2 && creatorCloseOnly && ticketObj.createdBy == userId) {
                    eachStatus.disabled = false
                }
                else if (eachStatus.ticketStatusId === 2 && creatorCloseOnly && ticketObj.createdBy !== userId) {
                    const relatedGroupAssignees = ticketGroupAssignee.filter(eachGroupAssignee => eachGroupAssignee.groupUserId == ticketObj.createdBy)
                    if(relatedGroupAssignees.length > 0){
                        const relatedGroupAssigneeUserIds = relatedGroupAssignees.map(eachAssignee => eachAssignee.userId)
                        if(relatedGroupAssigneeUserIds.includes(userId)){
                            eachStatus.disabled = false
                        }
                    }
                }
                else if (eachStatus.ticketStatusId === 2 && !creatorCloseOnly) {
                    eachStatus.disabled = false
                }
                else if (eachStatus.ticketStatusId === 8 && creatorCloseOnly && ticketObj.assignedTo === userId) {
                    eachStatus.disabled = false
                }
                else if (eachStatus.ticketStatusId === 9 && allowOnHold) {
                    eachStatus.disabled = false
                }
                return eachStatus
            })
    }

    const sortOrderByStatusIds = [1, 10, 8, 9, 2] 
    displayTicketStatuses?.sort((a, b) => {
        const indexA = sortOrderByStatusIds.indexOf(a.ticketStatusId)
        const indexB = sortOrderByStatusIds.indexOf(b.ticketStatusId)
        return indexA - indexB
    })

    const priority = [
        { label: 'Urgent', value: 'URGENT' },
        { label: 'Medium', value: 'MEDIUM' },
        { label: 'Low', value: 'LOW' },
        { label: 'High', value: 'HIGH' }
    ]

    useEffect(()=> {
        dispatch(fetchTicketStatus())
        dispatch(fetchTicketCategory())
        dispatch(fetchTicketSubCategory())
        dispatch(fetchTicketGroupAssignee(true))
        dispatch(fetchTicketConstraintAssignees())
        dispatch(fetchTicketDetailedStatus())
        dispatch(fetchLastCommentStructures())
        getBuyerCompaniesList()
        getTicket()

    }, [])

    useEffect(()=>{
        if(ticketObj.ticketStatusId === 10){
            let relatedSubCategory = ticketSubCategoies.find(each => each.ticketSubcategoryId === ticketObj.subcategoryId)
            if(relatedSubCategory && relatedSubCategory.detailedStatus){
                setShowDetailedStatus(true)
            }
        }else{
            setShowDetailedStatus(false)
        }
    },[ticketObj.ticketStatusId, ticketSubCategoies])

    const setLastViewedTime = (ticketId) => {
        localStorage.setItem(`ticket_${ticketId}_last_viewed`, new Date().toISOString())
        window.dispatchEvent(new Event('storage'))
    }

    useEffect(()=> {
        if (ticketSubCategoies && ticketSubCategoies.length > 0 && ticketObj) {
            const relatedCategory = ticketCategoies?.find(each => each.ticketCategoryId == ticketObj.categoryId);
            const relatedSubCategory = ticketSubCategoies.find(each => each.ticketSubcategoryId == ticketObj.subcategoryId);
            setEmailAlert(relatedSubCategory?.emailAlerts)

            if (relatedSubCategory && relatedSubCategory.defaultAssignee) {
                const relatedDefaultAssignees = []
                ticketGroupAssignee?.map(each => {
                    if (each?.groupUserId == relatedSubCategory.defaultAssignee) {
                        relatedDefaultAssignees.push(each?.userId);
                    }
                });
                // console.log("relatedDefaultAssignees", relatedDefaultAssignees)
                if(relatedDefaultAssignees){
                    updateAccessUserArr = [...updateAccessUserArr, ...relatedDefaultAssignees.filter(Boolean)];
                } else {
                    updateAccessUserArr = [...updateAccessUserArr];
                }
                setUpdateAccessUserArr(updateAccessUserArr)
                setDefaultTicketAssignees(relatedDefaultAssignees)
                if (updateAccessUserArr.includes(userId)) {
                    setIsUpdateEnabled(true);
                }
            }
            setTicketCategoryName(relatedCategory?.categoryName)
            setDueDateLock(relatedSubCategory?.dueDateLock)
            setAssigneeLock(relatedSubCategory?.assigneeLock)
            setAllowOnHold(relatedSubCategory?.allowOnHold)
            setCreatorCloseOnly(relatedSubCategory?.creatorCloseOnly)
            setSelectedSubCategoryName(relatedSubCategory?.subcategoryName)
            setIsReOpenAllow(relatedSubCategory?.allowReOpen)
        }
        if(ticketObj?.companyId){
            getCompanyDetail(ticketObj.companyId)
        }
        if (ticketConstraintAssignees && ticketObj) {
            const relatedAssignessIds = ticketConstraintAssignees
                .filter(each => each?.ticketSubcategoryId === ticketObj?.subcategoryId)
                .map(each => each?.userId);
            const filteredAssignees = userList?.filter(eachAssignee => relatedAssignessIds?.includes(eachAssignee?.userId))
            setSelectedAssigneeList(filteredAssignees)
        }

        if(ticketObj.subcategoryId){
            getConstraintFollowerList()
        }

        if(ticketObj.ticketId){
            setLastViewedTime(ticketObj.ticketId)
        }

    }, [ticketSubCategoies, ticketObj]);

    useEffect(() => {
        if (ticketSubCategoies && ticketSubCategoies.length > 0) {
            const relatedSubCategory = ticketSubCategoies.find(each => each.ticketSubcategoryId === initialTicketSubCategory);
            setIsSubCategoryEditable(relatedSubCategory?.editableSubCategory);
        }
        if(ticketObj.subcategoryId && [7, 8, 10].includes(ticketObj.subcategoryId)){
            setInitialSubCategoryIdAllowed(false)
        }
    }, [ticketSubCategoies, initialTicketSubCategory]);

    useEffect(()=>{
        getUsersList(ticketObj, updateAccessUserArr);
        if(ticketObj?.categoryId == 4){
            setDisableCompanyAndBranchName(false)
        }
    },[ticketObj, selectedFollowerList])

    useEffect(()=>{
        if(ticketObj.categoryId){
            let filteredSubCategoies = ticketSubCategoies?.filter(obj => obj.categoryId == ticketObj.categoryId)
            if(filteredSubCategoies){
                setTicketSubCategoryList(filteredSubCategoies)
            }
        }
    },[ticketObj.categoryId])

    useEffect(() => {
        if(companyList.length){
            const relatedCompany = companyList.find(eachCompany => eachCompany.companyId === selectedCompanyId)
            const relatedCompanyBranches = relatedCompany?.companyBranches || []
            if (relatedCompanyBranches.length > 0) {
                setCompanyBranchList(relatedCompanyBranches)
            }
        }

        if(ticketObj.companyId && ticketObj.companyId !== 0){
            if(buyerCompanies.length){
                const relatedCompany = buyerCompanies.find(eachCompany => eachCompany.companyId === ticketObj.companyId)
                if(relatedCompany){
                    setCompanyName(relatedCompany.companyName)
                }
            }
        }
        else{
            setSelectedCompanyId(null)
        }
        setSelectedCompanyId(ticketObj.companyId)
        if(ticketObj.companyId){
            setSelectedBranchId(ticketObj.branchId)
        }

    }, [ticketObj.companyId, buyerCompanies])

    const getCompanyDetail = async (companyId) => {
        const companyRes = await getCompanyListByCompanyId(companyId)
        if (!companyRes?.failure){
            setCompanyList(companyRes?.data)
        }
    }

    useEffect(()=>{
        if(selectedCompanyId){
            getCompanyBranches(selectedCompanyId)
        }
        else{
            setCompanyBranchList([])
        }

    },[selectedCompanyId])

    // useEffect(()=>{
    //     if(selectedCompany){
    //         getCompanyBranches(selectedCompany.companyId)
    //     }

    // },[selectedCompany])

    const getCompanyBranches = async (companyId)=>{
        const companyBranchRes = await getCompanyBranchesByCompanyId(companyId)
        if(companyBranchRes.failure){
            return dispatch(raiseToast({severity:'error', summary: "Fetch Buyer Companies", detail: companyBranchRes.data.error, life: 3000}))
        }
        else{
            setCompanyBranchList(companyBranchRes.data)
        }
    }

    const companyFuzzSearch = useCallback(new Fuse(buyerCompanies, {
        keys: ['companyName'],
        includeScore: true,
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: true,
        getFn: (obj) => {
            return obj.companyName.replace(/\s+/g, '')
        },
    }), [buyerCompanies])

    const companySearchMethod = (event) => {
        if(event.query === ""){
            setCompanySuggestions([...buyerCompanies])
        }
        else{
            const searchResults = companyFuzzSearch.search(event.query)
            const relatedCompanies = searchResults.map(eachProduct => eachProduct.item)
            setCompanySuggestions(relatedCompanies)
        }
    }

    const getBuyerCompaniesList = async ()=>{
        const buyerCompanyRes = await getBuyerCompanies()
        if(buyerCompanyRes.failure){
            return dispatch(raiseToast({severity:'error', summary: "Fetch Buyer Companies", detail: buyerCompanyRes.data.error, life: 3000}))
        }
        let updatedCompanyData = _.uniqBy(buyerCompanyRes.data.data, "companyId")
        updatedCompanyData = sortArrayOfObjectsInAlphabeticalOrder(updatedCompanyData, 'companyName')
        setBuyerCompanies(updatedCompanyData)
    }

    const handleCompanyChange = (e) => {
        if (e.target.value && typeof e.target.value === 'object') {
            setCompanyName(e.target.value.companyName)
            setSelectedCompanyId(e.target.value.companyId)
            setSelectedBranchId(null)
        } else {
            setCompanyName(e.target.value)
            setSelectedCompanyId(null)
        }
    }

    const handleBranchChange = (e) => {
        setSelectedBranchId(e.target.value)
    }

    const getTicket = async () => {
        const data = {
            ticketId: id
        }

        const res = await getTicketById(data)
        setIsInitialLoading(false)

        if(res.failure){
            return dispatch(raiseToast({severity:'error', summary: "getTicket", detail: res.data.error, life: 3000}))
        }

        const procmartUser = activeUserRoleDetails?.companyId === PMCompanyDetails.companyId

        if(res?.data){
            const ticketData = res.data?.data
            if(ticketData){
                const branchHeadUsers = usersList.filter(eachCompanyUser => {
                    if(eachCompanyUser.statusId === 1){
                        eachCompanyUser.userRoles.map(eachUserRole => {
                            if(eachUserRole.branchId === 3 && eachUserRole.statusId === 1){
                                return true
                            }
                        })
                    }
                    return false
                })
                const branchHeadUserIds = branchHeadUsers.map(eachUser => eachUser.userId)
                ticketData.branchHeadUsersId = branchHeadUserIds

                if(!procmartUser && ticketData?.createdBy != userId){
                    setAllowViewTicket(false)
                }else{
                    if (ticketData.ticketStatusId == 2){
                        setIsStatusClosed(true)
                    }
                    setTicketObj(ticketData)
                    setInitialTicketData(ticketData)
                    setInitialTicketSubCategory(ticketData.subcategoryId)
                    ticketData.followerDetails.map(eachFollower => {
                        let name = eachFollower.firstName
                        if(eachFollower.lastName){
                            name += " " + eachFollower.lastName
                        }
                        eachFollower.name = name
                    })
                    setSelectedFollower(ticketData.followerDetails)
                }
                setInitialTicketStatusId(ticketData.ticketStatusId)
            }
        }
    }

    const getConstraintFollowerList = async ()=>{
        const data = {
            subCategoryId: ticketObj.subcategoryId,
            companyId: activeUserRoleDetails.companyId
        }
        const constraintFollower = await getFollowerList(data)
        if (!constraintFollower?.failure){
            setSelectedFollowerList(constraintFollower?.data)
        }
    }

    const getUsersList = async (ticketObj, updateAccessUserArr) => {
        const usersData = usersList
        let userList = []
        usersData?.map((data) => {
            const userDetails = data
            if(userDetails){
                let userNameDetail =  userDetails.firstName
                if(userDetails.lastName){
                    userNameDetail  = userNameDetail + " " + userDetails.lastName
                }
                const userObj = {
                    userId: userDetails.userId,
                    firstName : userDetails.firstName,
                    lastName : userDetails.lastName,
                    name : userNameDetail,
                    statusId: userDetails.statusId
                }
                userList.push(userObj)
            }
        })

        const assignedUser = userList.find(obj => obj.userId == ticketObj.assignedTo)
        let updatedAccessUserArr = [...updateAccessUserArr]

        if(ticketObj?.branchHeadUsersId?.length > 0){
            updatedAccessUserArr = [...updatedAccessUserArr, ...ticketObj?.branchHeadUsersId]
        }

        if(ticketObj?.createdUser?.managerId){
            const managerId = ticketObj?.createdUser?.managerId
            updatedAccessUserArr = [...updatedAccessUserArr, managerId ]
        }
        
        const relatedSubCategory = ticketSubCategoies?.find(each => each.ticketSubcategoryId == ticketObj.subcategoryId)
        if (relatedSubCategory) {
            if (relatedSubCategory?.defaultAssignee == ticketObj.assignedTo) {
                const relatedDefaultAssignees = ticketGroupAssignee?.map(each => {
                    if (each?.groupUserId == relatedSubCategory?.defaultAssignee) {
                        return each?.userId
                    }
                })
                updatedAccessUserArr = [...updatedAccessUserArr, ...relatedDefaultAssignees]
            } else {
                const groupAssignee = ticketGroupAssignee?.find(each => each.groupUserId == ticketObj.assignedTo)
                if (groupAssignee) {
                    const relatedGroupAssignees = ticketGroupAssignee?.filter(each => each.groupUserId == ticketObj.assignedTo)?.map(each => each.userId)
                    updatedAccessUserArr = [...updatedAccessUserArr, ...relatedGroupAssignees]
                }
            }
        }

        if (ticketObj.assignedTo){
            updatedAccessUserArr.push(ticketObj.assignedTo);
        }

        if(ticketObj.createdBy){
            updatedAccessUserArr.push(ticketObj.createdBy)
        }

        if(ticketObj.createdBy !== userId){
            const relatedGroupAssignees = ticketGroupAssignee.filter(eachGroupAssignee => eachGroupAssignee.groupUserId == ticketObj.createdBy)
            const relatedGroupAssigneeUserIds = relatedGroupAssignees.map(eachAssignee => eachAssignee.userId)
            updatedAccessUserArr = [...updatedAccessUserArr, ...relatedGroupAssigneeUserIds]
        }

        if(updatedAccessUserArr.includes(userId)){
            setIsUpdateEnabled(true)
        }

        if(assignedUser){
            setSelectedAssignee(assignedUser)
        }

        if(ticketObj.createdUser){
            let createdUserName = ticketObj.createdUser.firstName
            if(ticketObj.createdUser.lastName){
                createdUserName = createdUserName + " " + ticketObj.createdUser.lastName
            }
            ticketObj.ticketCreatedUserName = createdUserName
        }

        getTicketComments(userList)

        userList = userList.sort(function (a, b) {
            if (a.name < b.name) {
                return -1
            }
            if (a.name > b.name) {
                return 1
            }
            return 0
        })

        setUserList(userList)
        setUpdateAccessUserArr(updatedAccessUserArr);
    }

    const getTicketComments = async () => {
        const res = await getTicketCommentsByTicketId(id)
        console.log("getCommentsById", res)
        const commentsData = res.data?.data

        if(commentsData?.length > 0){
            setCommentList(commentsData)
        }

    }

    const handleChange = (event) => {       
        if(event.target.name === 'ticketStatusId'){
            setIsTicketStatusChanged(true)
        }
        setTicketObj(prev => ({...prev, [event.target.name]: event.target.value }))
    }

    const handleComment = (event) => {
        setTicketComment(event.target.value)
    }

    const handleReOpenTicket = async () => {
        if(window.confirm("Are you sure to re-open?")){
            const data = {
                ticketId : ticketObj.ticketId,
                ticketEmailAlert : emailAlert,
                title : ticketObj.title,
                ticketStatusId : ticketObj.ticketStatusId,
                ticketFollowerIds : ticketObj.followerIds,
                ticketAssignedTo : ticketObj.assignedTo,
                ticketCreatorId : ticketObj.createdBy,
                defaultTicketAssignees : defaultTicketAssignees
            }
            setIsLoading(true)
            const response = await reOpenTicket(data)
            setIsLoading(false)
            if(response.failure){
                return dispatch(raiseToast({severity:'error', summary: "Ticket Re-Open ", detail: response.data.error, life: 3000}))
            }
            else{
                setTicketObj({...ticketObj, ticketStatusId : 1})
                setIsStatusClosed(false)
                setInitialTicketStatusId(1)
            }
        }
    }

    const handleEditTicket = async () =>{
        setAddCommentTriggered(false)
        let relatedSubCategory = ticketSubCategoies.find(each => each.ticketSubcategoryId === ticketObj.subcategoryId)
        if((relatedSubCategory.lastCommentStructured && creatorCloseOnly && isTicketStatusChanged && ticketObj.ticketStatusId === 8) ||
           (relatedSubCategory.lastCommentStructured && !creatorCloseOnly && ticketObj.ticketStatusId === 2)) {
            setShowStructuredCommentModel(true)
        }else{
            await editTicket(null)
        }
    }

    const editTicket = async (structuredComment) => {
        const userNameDetail = userDetails.userNameDetails

        let loggedInUserName = null
        if(userNameDetail){

            loggedInUserName = userNameDetail.firstName

            if(userNameDetail.lastName){
                loggedInUserName = loggedInUserName + " " + userNameDetail.lastName
            }
        }

        if(ticketObj.ticketStatusId === 10 && showDetailedStatus && !ticketObj.ticketDetailedStatusId){
            return dispatch(raiseToast({severity:'error', summary: "Edit Ticket", detail: 'Please select detailed status', life: 3000}))
        }

        const ticketStatusName = ticketStatus.find(obj => obj.ticketStatusId == ticketObj.ticketStatusId)?.statusName
        const ticketDetailedStatusName = ticketDetailedStatus.find(obj => obj.ticketDetailedStatusId == ticketObj.ticketDetailedStatusId)?.statusName
        const assigneeUserName = selectedAssignee?.name

        let ticketEditObj = {
            ticketId : id,
            ticketName : ticketObj.title,
            ticketDueDate : ticketObj.dueDate,
            ticketStatusId : ticketObj.ticketStatusId,
            ticketPriority : ticketObj.priority,
            ticketAssignedTo : ticketObj.assignedTo,
            ticketFollowerIds : ticketObj.followerIds,
            ticketCreatorId : ticketObj?.createdBy,
            defaultTicketAssignees : defaultTicketAssignees,
            ticketEmailAlert : emailAlert,
            ticketSubCategoryId : ticketObj?.subcategoryId,
            selectedSubCategoryName : selectedSubCategoryName,

            ticketStatusName : ticketStatusName,
            assigneeUserName : assigneeUserName,
            loggedInUserName : loggedInUserName,
            createdBy : userId,
            companyId : selectedCompanyId,
            branchId : selectedBranchId,
            ticketDetailedStatusId : ticketObj.ticketDetailedStatusId,
            ticketDetailedStatusName : ticketDetailedStatusName,
            structuredComment : structuredComment,
            docNo: ticketObj.docNo
        }
        if(selectedCompanyId){
            const relatedCompanyDetails = buyerCompanies.find(eachBuyerCompany=> eachBuyerCompany.companyId == selectedCompanyId)
            let companyName = null
            if (relatedCompanyDetails){
                companyName = relatedCompanyDetails.companyName
            }
            if(selectedBranchId){
                const relatedBranch = companyBranchList.find(eachCompanyBranch => eachCompanyBranch.branchId === selectedBranchId)
                if(relatedBranch){
                    const branchName = relatedBranch.branchName
                    ticketEditObj = {...ticketEditObj, companyName : companyName, branchName : branchName}
                }
            }
            else{
                return dispatch(raiseToast({severity:'error', summary: "Edit Ticket", detail: 'Please select branch', life: 3000})) 
            }
        }

        if(window.confirm("This will save changes do you want to proceed.?")){
            const res = await updateTicketFields(ticketEditObj, id)
            // console.log("res ---> updateTicketFields", res)
            
            if(res?.failure ){
                return dispatch(raiseToast({severity:'error', summary: "Edit Ticket", detail: res?.data?.error, life: 3000})) }
            else{
                if([7, 8, 10].includes(ticketObj.subcategoryId) && !isSubCategoryEditPermitted){
                    setInitialSubCategoryIdAllowed(false)
                }
                if(ticketStatusName == "Closed"){
                    setIsStatusClosed(true)
                    setInitialTicketStatusId(2)
                    const updatedTicketList = ticketList.filter(ticket => ticket.ticketId !== ticketObj.ticketId)
                    dispatch(updateTicketsData(updatedTicketList))
                    navigate('/tickets')
                }
                const updatedTicketObj = {
                    ...ticketObj,
                    companyId: selectedCompanyId,
                    branchId: selectedBranchId
                }
                
                setTicketObj(updatedTicketObj)
                setInitialTicketData(JSON.parse(JSON.stringify(updatedTicketObj)))

                dispatch(raiseToast({ severity: 'success', summary: 'Success Message', detail: 'Ticket Edited Successfully' }))
                getTicketComments(userList)
            }
        }
    }

    const handleOnChange = (e) => {
        if(e.target.name == "company"){
            setTicketObj({...ticketObj, companyId : e.target.value})
        }
        else if(e.target.name == "branch"){
            setTicketObj({...ticketObj, branchId : e.target.value})
        }   
    }

    const handleAddComment = async () =>{
        setAddCommentTriggered(true)
        let relatedSubCategory = ticketSubCategoies.find(each => each.ticketSubcategoryId === ticketObj.subcategoryId)
        if(relatedSubCategory.lastCommentStructured && !creatorCloseOnly && ticketObj.ticketStatusId === 2 ||
            relatedSubCategory.lastCommentStructured && creatorCloseOnly && initialTicketData.ticketStatusId !== ticketObj.ticketStatusId&& ticketObj.ticketStatusId === 8){
            setShowStructuredCommentModel(true)
        }else{
            await addComment(null)
        }
    }

    const addComment = async (structuredComment) => {
        if(!ticketComment){
            return Toast.current.show({ severity: 'error', summary: 'Error!', detail: 'Please enter a comment' })
        }

        setIsLoading(true)
        let commentObj = {
            ticketId : id,
            title : ticketObj?.title,
            ticketStatusId : ticketObj.ticketStatusId,
            createdBy : userId,
            ticketComment : ticketComment?.trim(),
            attachment : commentDocument,
            ticketFollowerIds : ticketObj?.followerIds,
            ticketAssignedTo : ticketObj?.assignedTo,
            ticketCreatorId : ticketObj?.createdBy,
            defaultTicketAssignees : defaultTicketAssignees,
            ticketEmailAlert : emailAlert,
            structuredComment : structuredComment
        }

        if(Object.values(commentUploadedFile).length > 0){
            commentObj.attachment = ''
            commentObj.uploadFile = commentUploadedFile
        }
        if(ticketObj?.ticketStatusId == 2 ){
            if(window.confirm("Are you sure you also want to close the ticket with your comment?")){
                const response =  await addTicketComment(commentObj)
                setAddCommentTriggered(false)
                setIsLoading(false)
                if(!response?.failure){
                    if(response?.data?.data){
                        setTicketComment('')
                        getTicketComments(userList, commentDocument)
                        setCommentDocument('')
                        setCommentUpladedFile({})
                    }
                    const updatedTicketList = ticketList.filter(ticket => ticket.ticketId !== ticketObj.ticketId)
                    dispatch(updateTicketsData(updatedTicketList))
                    navigate('/tickets')    
                }else{
                    return dispatch(raiseToast({severity:'error', summary: "Edit Ticket", detail: response?.data?.error, life: 3000})) 
                }
            }else{
                setIsLoading(false)
            }
        }else{
            const response =  await addTicketComment(commentObj)
            setAddCommentTriggered(false)
            setIsLoading(false)
            if(!response?.failure){
                if(response?.data?.data){
                    setTicketComment('')
                    getTicketComments(userList, commentDocument)
                    setCommentDocument('')
                    setCommentUpladedFile({})
                }
                const updatedTicketList = ticketList.map(ticket => {
                    if (ticket.ticketId === ticketObj.ticketId) {
                        return {
                            ...ticket,
                            ticketComments: [...ticket.ticketComments, response.data.data]
                        }
                    }
                    return ticket
                })
                dispatch(updateTicketsData(updatedTicketList))
            }else{
                return dispatch(raiseToast({severity:'error', summary: "Edit Ticket", detail: response?.data?.error, life: 3000})) 
            }
        }
        setInitialTicketData(ticketObj)
    }

    const handleAssigneeChange = (event) => {
        setSelectedAssignee(event.value)

        setTicketObj(prev => ({...prev, assignedTo: event.value?.userId}))
    }

    const handleFollowerChange = (event) => {
        setSelectedFollower(event.value)

        const followers = event.value
        const followerIds = [] 
        if(activeUserRoleDetails?.companyId === PMCompanyDetails.companyId){
            followers?.map((follower) => {
                followerIds.push(follower.userId)
            })
        }else{
            followers?.map((follower) => {
                followerIds.push(follower.userId)
            })
        }

        ticketObj['followerIds'] = followerIds

        setTicketObj({...ticketObj})
    }

    const searchAssignee = (event) => {
        const query = event.query.toLowerCase().trim();
        let assigneeList = activeUserRoleDetails?.companyId === PMCompanyDetails.companyId ? userList : selectedAssigneeList;
        
        assigneeList = assigneeList.filter(eachAsignee => eachAsignee.statusId === 1)

        const _filteredAssigneeUsers = !query.length 
            ? [...assigneeList]
            : assigneeList.filter((user) => {
                const fullName = `${user.firstName} ${user.lastName}`.toLowerCase()
                return fullName.includes(query)
            })
    
        setSearchedAssigneeNames(_filteredAssigneeUsers)
    }

    const searchFollower = (event) => {
        const query = event.query.toLowerCase().trim();
        const followerList = activeUserRoleDetails?.companyId === PMCompanyDetails.companyId
            ? [...userList, ...selectedFollower]
            : [...selectedFollowerList, ...selectedFollower]
    
        const _filteredFollowerUsers = !query.length 
            ? [...followerList]
            : followerList.filter((user) => {
                const fullName = `${user.firstName} ${user.lastName}`.toLowerCase()
                return fullName.includes(query)
            })
    
        setSearchedFollowerNames(_filteredFollowerUsers)
    }

    const documentUploadHandler = ({ files, options }, doc_name) => {
        const [file] = files;
        const fileReader = new FileReader();
        const blob = URL.createObjectURL(file); 
        file.objectURL = blob

        fileReader.onload = (e) => {
            setCommentUpladedFile({
                url: file.objectURL,
                documentName: doc_name,
                fileName: file.name,
                dataURI: e.target.result,
                inputName: options.props.name,
            })
            // setCommentDocument(file.objectURL)
            setCommentDocument(e.target.result)
            // uploadTicketDocument(doc_name, file.name, e.target.result, options.props.name);
        };
        fileReader.readAsDataURL(file);
        options.clear()
    }

    const removeTicketDocument = (event) => {
        event.stopPropagation();
        setCommentDocument("")
        setCommentUpladedFile({})
    }

    const handleCheckboxChange = (e, isPendingClosure) => {
        const newStatusId = e.target.checked
            ? isPendingClosure ? 8 : 2
            : 1
        setTicketObj({ ...ticketObj, ticketStatusId: newStatusId })
    }

    let description = ticketObj.description
    let title = ticketObj.title

    let createdBy = ""
    if(ticketObj.createdBy){
        const relatedUser = usersList.find(eachUser => eachUser.userId === ticketObj.createdBy)
        createdBy += "by " + getFullName(relatedUser.firstName, relatedUser.lastName)
    }

    let createdAt = ""
    if(ticketObj.createdAt){
        createdAt += " on " + moment(new Date(ticketObj.createdAt)).format(DATE_TIME_FORMAT)
    }

    if(isInitialLoading){
        return <TicketEditSkeleton />
    }

    const handleFileClick = (fileUrl) => {
        setSelectedFile(fileUrl)
        setUploadedFileView(true)
    }

    const renderCommentAttachmentDisplay = (ticketComment) => {
        if(ticketComment.attachment){
            const fileExtension = ticketComment.attachment.split('.').pop().toLowerCase()

            if(["jpg", "jpeg", "png", "txt", "pdf"].includes(fileExtension)){
                return <div className='m-0 ml-5'><FileDisplay type={fileExtension} url={ticketComment.attachment} /></div>
            }
            else{
                return <div className='m-0 ml-5'><Attachment url={ticketComment.attachment} displayFileName={true}/></div>
            }
        }
    }

    const isSubCategoryEditPermitted = checkPermissions({ ...userDetails, userRoleId: userDetails.activeRoleId, permissions: [206] })

    const canEditSubCategory = (initialSubCategoryIdAllowed && isSubCategoryEditable && isUpdateEnabled) || (isSubCategoryEditable && isSubCategoryEditPermitted)
    const canSaveChanges = (isUpdateEnabled && !isStatusClosed) || (isSubCategoryEditPermitted && !isStatusClosed)
    const pmCompanyBranch = PMCompanyDetails.companyBranches.find(eachCompanyBranch => eachCompanyBranch.branchId === ticketObj?.pmBranchId)
    const pmCompanyBranchName = pmCompanyBranch?.branchName

    const showPendingClosure = creatorCloseOnly && initialTicketData.assignedTo === userId
    /*let canCreatorChangeAssignee = false
    const uniqueGroupUserIds = [...new Set(ticketGroupAssignee.map(eachGroupAssignee => eachGroupAssignee.groupUserId))]
    if (uniqueGroupUserIds.includes(ticketObj.assignedTo)) {
        let relatedDefaultAssignees = ticketGroupAssignee.filter(eachGroupAssignee => {
            if (eachGroupAssignee.groupUserId == ticketObj.assignedTo) {
                return eachGroupAssignee.userId
            }
        })
        relatedDefaultAssignees = relatedDefaultAssignees.map(eachAssignee => eachAssignee.userId)
        if(relatedDefaultAssignees.includes(ticketObj.createdBy)){
            canCreatorChangeAssignee = true
        }
    }*/
    
    return (
        <>
        {
            allowViewTicket ?
            <div className='ticket-edit-container '>
                <div className='p-card'>
                    <Toast ref={Toast} />
                    <div className="card p-2"> 
                        <div className='flex flex-row justify-content-between'>
                            <div className='flex flex-row mb-0'>
                                <div>
                                    <span className="mb-0 ticket-title">{id} - {title}</span>&nbsp; 
                                    <span className='ticket-author ml-1'>{createdBy}<span className='mx-1'> {createdAt} </span> </span>  
                                </div>
                                <div className='mx-2 '>
                                </div>
                            </div>
                            <div className='flex justify-content-end h-1.5rem'>
                                <Button className="px-2 py-1 action-btn hover:surface-400 hover:text-700 surface-300" onClick={() => navigate(`/tickets`)} label="Drishti Home" />
                            </div>
                        </div>
                        <div  className="mt-2">
                            <div className="description-box">
                                <p className='m-0 font-500' style={{ whiteSpace: 'pre-line' }} >{description} </p>
                            </div>  
                        </div>
                        <div className=''>
                            <div className="flex flex-column md:flex-row lg:flex-row mt-2 p-0">
                                <div className="flex flex-column col-12 mb-1 md:col-2 lg:col-2 lg:mb-0 pl-0">
                                    <TextInputField name="ticketStatusId" labelText="Category"  value={ticketCategoryName} disabled />
                                </div>
                                <div className="flex flex-column col-12 mb-1 md:col-3 lg:col-3 lg:mb-0 pl-0">
                                    <DropDownField name="subcategoryId" labelText="Sub Category" options={ticketSubCategoryList} optionLabel="subcategoryName" optionValue="ticketSubcategoryId" value={ticketObj?.subcategoryId} onChange={(event) => handleChange(event)} disabled={!canEditSubCategory || isStatusClosed}/>
                                </div>
                                <div className="flex flex-column col-12 mb-1 md:col-2 lg:col-2 lg:mb-0 pl-0">
                                    <DropDownField name="ticketStatusId" labelText="Status" options={displayTicketStatuses} optionLabel="statusName" optionValue="ticketStatusId" value={ticketObj.ticketStatusId} onChange={(event) => handleChange(event)} disabled={!isUpdateEnabled || isStatusClosed }  />
                                </div>
                                <div className="flex flex-column col-12 mb-1 md:col-1 lg:col-1 lg:mb-0 pl-0">
                                    <DropDownField name="priority" labelText="Priority" options={priority} optionLabel="label" optionValue="value" value={ticketObj.priority?.toUpperCase()} onChange={(event) => handleChange(event)} disabled={!isUpdateEnabled || isStatusClosed}  />
                                </div>
                                <div className="flex flex-column col-12 mb-1 md:col-1 lg:col-2 lg:mb-0 pl-0">
                                    <CalendarField name="dueDate"  labelText="Due Date" placeholder="" value={new Date(ticketObj.dueDate)} onChange={(event) => handleChange(event)} showTime showIcon hourFormat="12" disabled={!isUpdateEnabled || isStatusClosed || dueDateLock} />
                                </div>
                                <div className="flex flex-column col-12 mb-1 md:col-3 lg:col-2 lg:mb-0 pr-0 pl-0 ticket-edit-autocomplete">
                                    <AutoCompleteField  className="w-100 py-4 px-4" labelText="Assign To" field="name" placeholder="Search assignee" value={selectedAssignee} suggestions={searchedAssigneeNames} searchMethod={searchAssignee} onChange={(event) => handleAssigneeChange(event)} dropdown forceSelection  display="chip" disabled={!isUpdateEnabled || isStatusClosed || assigneeLock} />
                                </div>
                            </div>

                            <div className="flex flex-column md:flex-row lg:flex-row mb-0 mt-1 pt-0 pl-0">
                                <div className={`flex flex-column ${ticketObj.attachment ? ' md:col-10 lg:col-10 sm:col-12' : 'col-12'} p-0`}>
                                    <div className="flex flex-column md:flex-row lg:flex-row mb-0 pt-0 pl-0">
                                        {
                                            (ticketObj.companyId || (ticketObj.companyId === 0 && !isStatusClosed))&&
                                            <div className="flex flex-column col-12 md:col-6 lg:col-6 lg:mb-0 pl-0 pt-0">
                                                <AutoCompleteField
                                                    dropdown
                                                    name="company"
                                                    labelText="Buyer Company"
                                                    field="companyName"
                                                    value={companyName}
                                                    searchMethod={companySearchMethod}
                                                    suggestions={companySuggestions}
                                                    onChange={handleCompanyChange}
                                                    dropdownButtonClassName="styled-autocomplete-dropdown-button"
                                                    forceSelection
                                                    disabled={(disableCompanyAndBranchName || !isUpdateEnabled || isStatusClosed) && ticketObj.companyId !== 0}
                                                />
                                            </div>
                                        }
                                        {
                                            ((ticketObj.companyId && ticketObj.branchId) || (ticketObj.companyId && !ticketObj.branchId && !isStatusClosed) || (ticketObj.companyId === 0 && !isStatusClosed)) && 
                                            <div className={`flex flex-column col-12 md:col-3 lg:col-3 lg:mb-0 pl-0 pt-0`}>
                                                <DropDownField name="branch" field="branchName" options={companyBranchList} optionLabel="branchName" optionValue="branchId" onChange={handleBranchChange} labelText="Branch" value={selectedBranchId} 
                                                disabled={(disableCompanyAndBranchName || !isUpdateEnabled || isStatusClosed) &&   (
                                                    ticketObj?.companyId == null || 
                                                    (ticketObj.companyId && ticketObj.branchId)
                                                )}/>    
                                            </div>
                                        }
                                        
                                        {showDetailedStatus &&
                                            <div className={`flex flex-column col-12 md:col-3 lg:col-3 lg:mb-0 pl-0 pt-0`}>
                                                <DropDownField name="ticketDetailedStatusId" labelText="Detailed Status" options={ticketDetailedStatus} optionLabel="statusName" optionValue="ticketDetailedStatusId" value={ticketObj.ticketDetailedStatusId} onChange={(event) => handleChange(event)} disabled={!isUpdateEnabled || isStatusClosed }  />
                                            </div>
                                        }
                                        {
                                            pmCompanyBranchName &&
                                            <div className="flex flex-column col-12 mb-1 md:col-3 lg:col-3 lg:mb-0 pl-0 pt-0">
                                                <TextInputField name="pmBranchId" labelText="Pm Branch" value={pmCompanyBranchName} disabled/>
                                            </div>
                                        }
                                    </div>

                                    <div className="flex flex-row mb-0 p-0 mt-1">
                                        <div className='flex flex-column col-12 m-0 p-0 ticket-edit-autocomplete'>
                                            <AutoCompleteField customFieldStyle={{minheight:"34px" }} className="w-100 py-8 px-4" labelText="Follower" field="name" placeholder="Search Follower" value={selectedFollower} suggestions={searchedFollowerNames} searchMethod={searchFollower}  multiple onChange={(event) => handleFollowerChange(event)} dropdown forceSelection disabled={!isUpdateEnabled || isStatusClosed}  />
                                        </div>
                                    </div>
                                </div>
                                
                                { ticketObj.attachment ?
                                    <div className="flex flex-column col-12 md:col-2 lg:col-2 lg:mb-0 mt-2 sm:pt-1 pl-0 md:mt-0 lg:mt-0 pt-0 pr-0  md:align-items-end lg:align-items-end">
                                        <div className='pl-0'>
                                            <h6 className="mb-0 lg:ml-2 md:ml-2">File</h6>
                                            <div className='p-2 pt-0 pr-0 flex pl-0'>
                                                {
                                                    (["png", "jpeg", "jpg"].includes(ticketObj.attachment.split('.').pop().toLowerCase())) ?
                                                        <>
                                                            <img src={ticketObj.attachment} width={100} height={100} style={{ objectFit: 'cover', cursor: 'pointer', borderRadius: 8 }} onClick={() => setIsDocDialogVisible(true)} alt="Attachment preview" />
                                                            <Dialog visible={isDocDialogVisible} onHide={() => setIsDocDialogVisible(false)} style={{ width: '85vw', height: '85vh', overflow: "auto" }} maximizable >
                                                                <DocumentView fileUrl={ticketObj.attachment} showZoomControl={true} />
                                                            </Dialog>
                                                        </>
                                                        : (ticketObj.attachment.split('.').pop().toLowerCase() === 'pdf') ?
                                                            <>
                                                                <div style={{ width: 100, height: 100, cursor: 'pointer', borderRadius: 8, overflow: 'hidden', background: '#bbb', border: '1px solid #ccc', boxShadow: '0 2px 6px rgba(0,0,0,0.10)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setIsDocDialogVisible(true)}>
                                                                    <Document file={ticketObj.attachment} loading="" noData="">
                                                                        <Page pageNumber={1} width={90} height={90} />
                                                                    </Document>
                                                                </div>
                                                                <Dialog visible={isDocDialogVisible} onHide={() => setIsDocDialogVisible(false)} style={{ width: '85vw', height: '85vh', overflow: "auto" }} maximizable >
                                                                    <DocumentView fileUrl={ticketObj.attachment} showZoomControl={true} />
                                                                </Dialog>
                                                            </>
                                                        :
                                                        <div className='flex justify-content-between'>
                                                            <Attachment url={ticketObj.attachment} />
                                                        </div>
                                                } 
                                            </div> 
                                        </div> 
                                    </div> : null
                                }
                            </div>

                            <div className='flex flex-row col-12 md:mt-3 lg:mt-3 mt-2 justify-content-center'>
                                {
                                    initialTicketStatusId !== 2 ?
                                    <Button className="small-btn" style={{height : "35px", width: "190px"}} label="Save Changes" onClick={(e) => handleEditTicket(e)} disabled={!isUpdateEnabled || isStatusClosed} />
                                    :
                                    <Button className="small-btn" style={{height : "35px", width: "100px"}} label="Re Open" onClick={(e) => handleReOpenTicket(e)} disabled={!(ticketObj.createdBy === userId && isReOpenAllow)} />
                                }
                            </div>
                        </div>

                        {ticketObj?.ticketParamValues && typeof ticketObj.ticketParamValues === 'object' && Object.keys(ticketObj.ticketParamValues).length > 0  ? (
                            <>
                                <h5 className="mb-1 mt-3">Additional Details</h5>
                                {Object.keys(ticketObj.ticketParamValues).reduce((acc, _, index) => {
                                    if (index % 3 === 0) {
                                        return acc.concat([Object.keys(ticketObj.ticketParamValues).slice(index, index + 3)])
                                    }
                                    return acc
                                }, []).map((subParamGroup, rowIndex) => (
                                    <div key={rowIndex} className="flex flex-wrap col-12 pl-0 pt-0">
                                        {subParamGroup.map((paramKey) => {
                                            let paramValue = ticketObj.ticketParamValues[paramKey] || ''
                                            const isDateParam = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z$/.test(paramValue)
                                            if (isDateParam) {
                                                const dateObj = new Date(paramValue)
                                                const time = dateObj.toISOString().substr(11, 8)
                                                if (time === '00:00:00') {
                                                    paramValue = moment(dateObj).format(DATE_FORMAT)
                                                } else {
                                                    paramValue = moment(dateObj).format(DATE_TIME_FORMAT)
                                                }
                                            }
                                            const updatedParamKey = paramKey.replace(/\b\w/g, function (char) {
                                                return char.toUpperCase()
                                            })

                                            return (
                                                <div key={paramKey} className={`flex flex-column col-12 mb-2 md:col-4 lg:col-4 lg:mb-0`}>
                                                    <TextInputField
                                                        name={paramKey}
                                                        labelText={updatedParamKey}
                                                        value={paramValue}
                                                        disabled
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                ))}
                            </>
                        ) : null}
                    </div>
                </div>

                <div className='p-card mb-0'>
                    <div className="card p-2 pt-0">
                        {
                            isStatusClosed ? '' :
                            <>
                                <div className="flex flex-column md:flex-row lg:flex-row md:justify-content-between lg:justify-content-between">
                                    <div className="flex flex-column col-12  md:col-10 lg:col-10 lg:mb-0 pl-0">
                                        <div className="flex flex-column col-12 lg:col-12 pb-0 pr-0">
                                            <h5 className='my-2'>Add Comment</h5>
                                            <TextAreaField id="remarks-text-area" name="ticketCommentInput" rows={5} onChange={(e) => handleComment(e)} value={ticketComment} />
                                        </div>
                                        <div className='flex flex-row justify-content-between'>
                                            <div className='flex flex-row justify-content-start'>
                                                <div className="ml-2 my-2">
                                                    <CheckboxField
                                                        checked={
                                                            (showPendingClosure && ticketObj.ticketStatusId === 8) ||
                                                            (!showPendingClosure && ticketObj.ticketStatusId === 2)
                                                        }
                                                        onChange={(e) => handleCheckboxChange(e, showPendingClosure)}
                                                        disabled={
                                                            !isUpdateEnabled ||
                                                            isStatusClosed ||
                                                            !ticketComment ||
                                                            (!showPendingClosure && creatorCloseOnly && ticketObj.createdBy !== userId) || 
                                                            (showPendingClosure && initialTicketData.ticketStatusId === 8)
                                                        }
                                                    />
                                                </div>
                                                <p className={`ml-2 my-2 custom-tooltip-${ticketObj?.ticketId}`}>
                                                    {showPendingClosure ? 'Pending Closure' : 'Close Ticket'}
                                                </p>
                                            </div>
                                            <div className='flex justify-content-center pl-0 pr-0' style={{ marginTop: '0px', paddingTop: '0px' }}>
                                                <Button label="Add comment" onClick={(e) => handleAddComment(e)} className="add-comment-button-inclined" style={{width: "160px", height: "25px"}}/>
                                            </div>
                                        </div>
                                        <Tooltip target={`.custom-tooltip-${ticketObj?.ticketId}`} position="top" autoHide>
                                            <p>
                                                {showPendingClosure
                                                    ? 'Select this option to mark the ticket pending closure automatically with your add comment.'
                                                    : 'Select this option to close the ticket automatically with your add comment.'}
                                            </p>
                                        </Tooltip>
                                    </div>
                                    <div className="flex flex-column col-12 md:col-2 lg:col-2 lg:mb-0 align-items-start">
                                        <h5 className='md:my-2 lg:my-2 mb-2 mt-0 ml-1 pt-2'> Upload File </h5>
                                        {
                                            !commentDocument ?
                                            <FileUpload mode="basic" name="ticketDocument" accept=".jpg,.jpeg,.png,.pdf,.csv,.xls,.xlsx" maxFileSize={5000000} customUpload  uploadHandler={(files) => documentUploadHandler(files, "TICKET_DOCUMENT")} auto chooseLabel="Upload File" />
                                            :
                                            <div className='flex gap-1'>
                                                <div >
                                                    { 
                                                        ["png","jpeg", "jpg"].includes(commentDocument) ? 
                                                            <img src={commentDocument} width="90" height="90" />
                                                            :
                                                            (commentUploadedFile?.fileName?.toLowerCase().includes('csv') || commentUploadedFile?.fileName?.toLowerCase().includes('xls') || commentUploadedFile?.fileName?.toLowerCase().includes('xlsx')) ? 
                                                                <div className='flex justify-content-between'>
                                                                    <div className=''>
                                                                        <a href={commentUploadedFile?.url} ><p>View</p></a>
                                                                    </div>
                                                                    <div onClick={removeTicketDocument} className='mx-5'>
                                                                        <p>Remove</p>
                                                                    </div>
                                                                </div>
                                                            :
                                                            <div>
                                                                <div className='ticket-upload-file' style={{ position: "relative"}}>
                                                                    <embed src={commentDocument} width="100" height="100" className='' />
                                                                    <div className="pdfview" onClick={(e) => setUploadedCommentFileView(true)}>
                                                                </div>
                                                                    <i className="pi pi-times delete-icon" onClick={(event) => removeTicketDocument(event)} />
                                                                </div>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                               
                            </>
                        }
                        {
                            commentList.length !== 0 && 
                            <div className="grid m-2 mt-0 flex flex-column">
                                <h5 className="mb-1 mt-5" style={{color: "grey"}}>Comments</h5> 
                                {
                                    commentList.length == 0 ?  '' 
                                    :
                                    commentList.map((obj) => {
                                        let strippedCommentHtml = obj.comment?.replace(/<[^>]+>/g, '')
                                        
                                        return (
                                            <>
                                                <div className={`comment-container`}>
                                                    <div className='flex flex-row'>
                                                        <UserProfile userNameDetails={obj} className="comment-profile-img"/>
                                                        <div className="flex flex-column ml-2">
                                                            <h5 className="">{ getFullName(obj.firstName, obj.lastName)}</h5>
                                                            <span className="time-right">{(moment(new Date(obj.createdAt)).format(DATE_TIME_FORMAT))}</span>
                                                        </div>
                                                    </div>
                                                    <div className='p-2 ml-5'>
                                                        <p className='m-0'>{strippedCommentHtml}</p>
                                                    </div>
                                                    {
                                                        renderCommentAttachmentDisplay(obj)
                                                    }
                                                </div>
                                            </>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>

                    <Dialog visible={uploadedCommentFileView} style={{ width: '85vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setUploadedCommentFileView(false)}>
                        <div className='image-dialog-container' style={{ width: "100%", height: '100%'}}>
                            { 
                                ["png", "jpeg", "jpg"].includes(commentDocument) ? 
                                    <img src={commentDocument} className='uploaded-image' />
                                    :
                                    <embed src={commentDocument} className='uploaded-image' width="100%" height="100%" /> 
                            }
                        </div>
                    </Dialog>

                    <Dialog visible={uploadedFileView} style={{ width: '85vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setUploadedFileView(false)}>
                        <div className='image-dialog-container' style={{ width: "100%", height: '100%'}}>
                           {selectedFile && selectedFile.split('.').pop().toLowerCase() === 'pdf' ? (
                                <embed
                                    src={selectedFile}
                                    width="100%"
                                    height="100%"
                                    type="application/pdf"
                                    style={{ border: 'none' }}
                                />
                            ) : (
                                <img
                                    src={selectedFile}
                                    className="uploaded-image"
                                    width="100%"
                                    height="100%"
                                    alt="expanded attachment"
                                />
                            )}
                        </div>
                    </Dialog>
                    <Loading visible={isLoading} />
                </div>
            </div> 
            :         
            <div className="notification">
                <p className="punch-msg" style={{ textAlign: "center", fontWeight: "bold", color: "red"}}>You Do Not Have Permission!</p>
            </div>
        } 

        <Dialog header="CLOSING COMMENT" visible={showStructuredCommentModel} style={{ width: '50vw', minHeight: "30vh", }} onHide={() => setShowStructuredCommentModel(false)}>
            <StructuredCommentModel lastCommentStructure={lastCommentStructure} subCategoryId={ticketObj.subcategoryId} setShowStructuredCommentModel={setShowStructuredCommentModel} addComment={addComment} addCommentTriggered={addCommentTriggered} editTicket={editTicket}/>
        </Dialog>
        </>
    )
}

export default TicketEdit